/**
 * Organization schema.org data shared by Organization JSON-LD.
 * Extend with address, foundingDate, etc. when available.
 */
import { HOMEPAGE_META_DESCRIPTION } from "./homepage-meta";
import { CANONICAL_HOMEPAGE_URL, OG_IMAGE_URL } from "./site-urls";

export const ORGANIZATION_ID = `${CANONICAL_HOMEPAGE_URL}#organization`;

export const ORGANIZATION_NAME = "Radivision";

/** From site copyright headers; confirm before adding to public schema if needed. */
export const ORGANIZATION_LEGAL_NAME = "Radivision Inc.";

export const ORGANIZATION_DESCRIPTION = HOMEPAGE_META_DESCRIPTION;

export const ORGANIZATION_LOGO_URL = OG_IMAGE_URL;

export const ORGANIZATION_SAME_AS = [
  "https://www.facebook.com/radivision/",
  "https://www.instagram.com/radivision/",
  "https://twitter.com/radivisiontv",
  "https://www.linkedin.com/company/radivision/",
] as const;

export const ORGANIZATION_CONTACT_EMAIL = "support@radivision.com";

export const ORGANIZATION_CONTACT_URL = `${CANONICAL_HOMEPAGE_URL}support#:contact-us`;
